import { Component, OnInit } from '@angular/core';
import { SelectionModel } from '@angular/cdk/collections';

import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { IntervenersDigitalSignatureDTO, IntervenientsDTO } from '../../model/logalty-signature-model';
import { DigitalSignatureServiceStore } from '../digital-signature-service/digital-signature-service.store';
import { ResponseDialogComponent } from '@app/@shared/dialogs/response/response-dialog.component';
import {
  FINANCIAL_PRODUCT,
  CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO,
  CONSTANTE_MARCA,
  LOGALTY_STATE_REFUSED,
  LOGALTY_STATE_REFUSED_INTERVENER,
  LOGALTY_STATE_CANCELED,
} from '@app/@core/constants/logalty-digital-signature.constants';
import { DigitalSignatureCommonService } from '../digital-signature-service/digital-signature-common.service ';
import { CommonDataDTO } from '@app/requests/model/combos-model';
import { DetectDeviceService } from '@app/@shared/services/utils/detect-device.service';
import { CredentialsService } from '@app/login';
import { UserType } from '@app/@core/constants/user-credentials.constants';

import { DigitalSignatureServiceApi } from '../digital-signature-service/digital-signature-service-api.service';

@Component({
  selector: 'app-participants-list',
  templateUrl: './participants-list.component.html',
  styleUrls: ['./participants-list.component.scss'],
})
export class ParticipantsListComponent implements OnInit {
  public comarca: string;
  public numOperation: string;
  public isPrintOption: boolean = false;
  public pendingForm: FormGroup;
  public isAsyncSignature: boolean;
  public isComeFromSign: boolean = false;

  dataSource = new MatTableDataSource<IntervenientsDTO>();

  displayedColumns: string[] = ['select', 'dni', 'name', 'surname', 'surname2', 'mobile', 'email', 'role', 'guid'];
  selection = new SelectionModel<any>(false, []);
  dataNotice: CommonDataDTO[] = [];

  constructor(
    public router: Router,
    public route: ActivatedRoute,
    private formBuilder: FormBuilder,
    public dialog: MatDialog,
    public translate: TranslateService,
    public storageSignature: DigitalSignatureServiceStore,
    public digitalSignatureCommonService: DigitalSignatureCommonService,
    private detectDeviceService: DetectDeviceService,
    private credentialsService: CredentialsService
  ) {}

  ngOnInit(): void {
    this.route.params.subscribe((params) => {
      this.numOperation = params['numOperation'];
      this.isPrintOption = params['isPrintOption'] === 'true' ? true : false;
      this.comarca = params['comarca'];
    });
    console.log('print option participants: ', this.isPrintOption);
    this.createForm();
    this.isAsyncSignature = false;

    this.digitalSignatureCommonService.ParticipantsListObserver().subscribe((data: IntervenersDigitalSignatureDTO) => {
      if (data) {
        this.dataSource.data = data.interveners;
        //subscribe to observer CancelConsents, if true show dialog with consents cancel errors -> this.showCancelConsentsError( error );
        let cancelConsent = this.digitalSignatureCommonService.CancelConsents();
        if (cancelConsent) {
          const dialogConfig = new MatDialogConfig();
          dialogConfig.width = '90%';
          dialogConfig.maxWidth = '450px';
          this.showDialogCancelConsentsError(dialogConfig);
        }
        // show errors validations that comes in data for every participant -> this.showDialogErrorGetParticipants(data);
        if (data.notice.length > 0) {
          this.dataNotice = data.notice;
        }
      } else {
        let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
        this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
      }
    });
  }

  ngAfterViewInit() {
    if (this.dataNotice.length > 0) {
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '90%';
      dialogConfig.maxWidth = '450px';
      setTimeout(() => {
        this.showDialogErrorGetParticipants(this.dataNotice, dialogConfig);
      }, 0);
    }
  }

  public goToPanel() {
    if (this.credentialsService.credentials.userType === UserType.ADMIN) {
      this.router.navigate(['/users/search-operation', { keepFilter: true }]);
    } else {
      let pageOpenSignature = JSON.parse(localStorage.getItem('pageOpenSignature'));
      this.router.navigate([pageOpenSignature.url, { keepFilter: true }]);
    }
  }

  public signClick() {
    let accessByDeviceDTO = this.detectDeviceService.isAccessByDevice();
    let selectedValue = this.pendingForm.controls.pending.value;

    console.log('selected value: ', selectedValue);

    //check if has insurance
    if (selectedValue.businessCIF.length > 0) {
      this.isPrintOption
        ? this.storageSignature.printContractAfterConsentsGoPanel()
        : this.storageSignature.goToSignatureLogalty(selectedValue, accessByDeviceDTO);
    } else {
      let operation = this.storageSignature.getOperationDataInstant();

      if (!this.isPrintOption && this.storageSignature.isConsentsAllowed(operation))
        this.storageSignature.goToSignatureLogalty(selectedValue, accessByDeviceDTO);
      else this.storageSignature.goToConsentsLogalty(selectedValue, this.isPrintOption, accessByDeviceDTO);
    }
    this.isComeFromSign = true;
  }

  // check if has insurance
  private checkTitularInsurance(intervinientSelected: any): boolean {
    console.log('interviniente datos: ', intervinientSelected);

    if (this.comarca === 'AUTOS' && !this.isPrintOption) {
      const intervWithInsurance = this.dataSource.data.find((intervinient) => intervinient.insuranceInter === 'S');
      if (
        intervinientSelected.insuranceInter === 'S' ||
        (intervinientSelected.insuranceInter === 'N' &&
          (!intervWithInsurance || intervWithInsurance.document_result === '7'))
      ) {
        return true;
      } else {
        return false;
      }
    } else {
      return true;
    }
  }

  public sendEmailClick() {
    //TODO: check if open the popup or call the service
    let selectedValue = this.pendingForm.controls.pending.value;
    console.log(' participant selected: ', selectedValue);
    this.storageSignature.sendEmailAsyncSignature(this.numOperation);
  }

  private createForm() {
    this.pendingForm = this.formBuilder.group({
      pending: ['', Validators.required],
    });
  }

  private showDialogCancelConsentsError(dialogConfig: MatDialogConfig, error?: string) {
    let errorDescription: string = '';

    //TODO:get message with phone
    errorDescription = this.getTelCancelConsentsMessage();

    dialogConfig.data = {
      text: errorDescription,
      icon: undefined,
      title: this.translate.instant('logalty.error.title'),
    };

    this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  //TODO: test
  private getTelCancelConsentsMessage() {
    //get the phone for product and brand
    let operation = this.storageSignature.getOperationDataInstant();
    let codProd = operation.prod;
    let brand = operation.comarca;
    let phone: string = '';
    let message: string;

    if (
      FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_AUTOS.match(codProd) ||
      FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_LEASING.match(codProd)
    ) {
      phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_AUTO_LEASING;
    } else if (FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_CONSUMO.match(codProd)) {
      phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_CONSUMO;
    } else if (FINANCIAL_PRODUCT.CONSTANTE_PRODUCTO_FINANCIERO_TARJETAS.match(codProd)) {
      if (CONSTANTE_MARCA.TODAY.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_TODAY;
      } else if (CONSTANTE_MARCA.MANGO.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_MANGO;
      } else if (CONSTANTE_MARCA.BONPREU.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_BONPREU;
      } else if (CONSTANTE_MARCA.REPSOL.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_REPSOL;
      } else if (CONSTANTE_MARCA.CUENTA_GASOLEO.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_CG;
      } else if (CONSTANTE_MARCA.CE.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_CE_CD_CF;
      } else if (CONSTANTE_MARCA.CUENTA_DEPORTES.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_CE_CD_CF;
      } else if (CONSTANTE_MARCA.CF.match(brand)) {
        phone = CONSTANTE_CONSENTS_RECHAZADOS_TELEFONO.TELEFONO_CE_CD_CF;
      }
    }

    if (phone != '') message = this.translate.instant('logalty.consents.rechazados', { number: phone });
    else message = this.translate.instant('logalty.consents.rechazados.generico');

    return message;
  }

  private showDialogErrorGetParticipants(messages: CommonDataDTO[], dialogConfig: MatDialogConfig) {
    let errorDescription: string = '';
    //for every participant in the list check error and add to description
    messages.forEach((error) => {
      if (error.id == 'error.signature_not_allowed_by_import') {
        if (!this.isPrintOption) errorDescription = this.translate.instant('signature.notallowed.byimport.text');
      } else errorDescription += this.translate.instant(error.id, { dni: error.value });
    });
    dialogConfig.data = {
      text: errorDescription,
      icon: undefined,
      title: this.translate.instant('logalty.error.title'),
    };

    if (errorDescription != '') this.dialog.open(ResponseDialogComponent, dialogConfig);
  }

  isDisabled(document_result: string): boolean {
    if (
      (this.dataNotice.find((item) => item.value == 'error.signature_not_allowed_by_import') && !this.isPrintOption) ||
      document_result === '7'
    ) {
      return true;
    }
    return false;
  }

  ngOnDestroy() {
    this.digitalSignatureCommonService.setCancelConsents(false);
  }

  onClickRadioButton = (event: any, element: any) => {
    console.log('onClickRadioButton - Start', [event, element]);
    event.stopPropagation();
    const documentResult = element?.document_result;
    if (
      documentResult === LOGALTY_STATE_REFUSED ||
      documentResult === LOGALTY_STATE_REFUSED_INTERVENER ||
      documentResult === LOGALTY_STATE_CANCELED
    ) {
      event.preventDefault();
      const dialogConfig = new MatDialogConfig();
      dialogConfig.width = '90%';
      dialogConfig.maxWidth = '450px';
      dialogConfig.data = {
        text:
          documentResult === LOGALTY_STATE_REFUSED_INTERVENER
            ? this.translate.instant('signature.dialog.refused.intervener.content')
            : this.translate.instant('signature.dialog.refused.content'),
        icon: undefined,
        title: this.translate.instant('logalty.error.firmaNoPermitida'),
      };
      this.dialog.open(ResponseDialogComponent, dialogConfig);
    }
  };
}
